import { render, staticRenderFns } from "./EditRepairCategory.vue?vue&type=template&id=80f0140a&scoped=true&"
import script from "./EditRepairCategory.vue?vue&type=script&lang=js&"
export * from "./EditRepairCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditRepairCategory.vue?vue&type=style&index=0&id=80f0140a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f0140a",
  null
  
)

export default component.exports